import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { DATA_SOURCE_ICONS } from './constants';
import { DataSourceIconBaseProps } from './types';

type DataSourceIconProps = DataSourceIconBaseProps & {
  type: string;
};

export const DataSourceIcon: FC<DataSourceIconProps> = ({ type, className }) => {
  const Icon = DATA_SOURCE_ICONS[type];

  return <>{Icon ? <Icon className={twMerge('size-12 text-brand-500 shrink-0', className)} /> : null}</>;
};
